__turbopack_context__.v({
  "checkmark": "LanguageSwitcher-module-scss-module__q57RXG__checkmark",
  "chevron": "LanguageSwitcher-module-scss-module__q57RXG__chevron",
  "code": "LanguageSwitcher-module-scss-module__q57RXG__code",
  "dropdown": "LanguageSwitcher-module-scss-module__q57RXG__dropdown",
  "fadeDown": "LanguageSwitcher-module-scss-module__q57RXG__fadeDown",
  "flag": "LanguageSwitcher-module-scss-module__q57RXG__flag",
  "open": "LanguageSwitcher-module-scss-module__q57RXG__open",
  "option": "LanguageSwitcher-module-scss-module__q57RXG__option",
  "optionName": "LanguageSwitcher-module-scss-module__q57RXG__optionName",
  "shimmer": "LanguageSwitcher-module-scss-module__q57RXG__shimmer",
  "trigger": "LanguageSwitcher-module-scss-module__q57RXG__trigger",
  "wrapper": "LanguageSwitcher-module-scss-module__q57RXG__wrapper",
});
